import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoRegistroContableService } from '@services/tipoRegistroContable/tipoRegistroContable.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { BaseDto } from '@models/base/baseDto.model';
import { DialogTipoRegistroContableGenericComponent } from '../../tipos-movimiento/dialog-tipo-movimiento-generic/dialog-tipo-registro-contable-generic.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { SinDatosParaMostrarComponent } from '@component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';

@Component({
  standalone:true,
      imports:[CommonModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatDialogModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        NgxSpinnerModule,
        AppRolesDirective, // tu directiva personalizada standalone
        SinDatosParaMostrarComponent],
  selector: 'app-list-tipo-registro-contable',
  templateUrl: './list-tipo-registro-contable.component.html',
  styleUrls: ['./list-tipo-registro-contable.component.css']
})
export class ListTipoRegistroContableComponent {

  dataSource = new MatTableDataSource<BaseDto>();
  obj!: undefined
  displayedColumns: string[] = ['descripcion', 'accion'];
  data = false

  @ViewChild(MatTable, { static: true }) table!: MatTable<BaseDto>;

  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  constructor(
    public dialog: MatDialog,
    private tipoRegistroContableService: TipoRegistroContableService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'accion'] :
        ['descripcion', 'accion'];
    });
  }


  ngOnInit() {

  }

  filtrar(){
    this.getTiposRegistroContable();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getTiposRegistroContable() {
    this.spinner.show('spTiposRegistroContable')
    this.tipoRegistroContableService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spTiposRegistroContable')
          this.dataSource.data = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()));
          this.data = this.dataSource.data.length >= 1 ?  true : false
        },
        error => {
          this.spinner.hide('spTiposRegistroContable')
          this.snackBar.showError( error, "Error");
        }
      )
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = obj
    dialogConfig.width = "30%"
    const dialogRef = this.dialog.open(DialogTipoRegistroContableGenericComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Agregar) {
        //this.addRowData(result.data);
        this.getTiposRegistroContable();
      } else if (result.event == AccionesDialog.Modificar) {
        this.getTiposRegistroContable();
        //this.updateRowData(result.data);
      } else if (result.event == AccionesDialog.Eliminar) {
        this.getTiposRegistroContable();
        //this.deleteRowData(result.data);
      }
    });
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


//   addRowData(row_obj: { descripcion: any, valor: any }) {
//     this.spinner.show()
//     let createTipoSelladoRequest = new CreateTipoSelladoRequest
//     createTipoSelladoRequest.descripcion = row_obj.descripcion
//     createTipoSelladoRequest.valor = row_obj.valor

//     let existe = false
//     this.dataSource.data.forEach((element, index) => {
//       if (element.descripcion === row_obj.descripcion)
//         existe = true
//     });

//     if (createTipoSelladoRequest && !existe) {
//       this.tiposSelladoService.create(createTipoSelladoRequest)
//         .subscribe(
//           data => {
//             this.spinner.hide()
//             this.getTiposSelladoService()
//             this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
//           },
//           error => {
//             this.spinner.hide()
//             this.snackBar.showError( error, "Error");
//           }
//         )
//     }
//     else {
//       this.spinner.hide()
//       this.snackBar.showWarn("El registro ya existe", "Error");
//     }
//   }
//   updateRowData(row_obj: { id: number; descripcion: string, valor: number }) {
//     this.spinner.show()
//     let updateTipoSelladoRequest = new UpdateTipoSelladoRequest
//     updateTipoSelladoRequest.id = row_obj.id
//     updateTipoSelladoRequest.descripcion = row_obj.descripcion
//     updateTipoSelladoRequest.valor = row_obj.valor

//     if (updateTipoSelladoRequest) {
//       this.tiposSelladoService.update(updateTipoSelladoRequest)
//         .subscribe(
//           data => {
//             this.spinner.hide()
//             this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string, valor: number; }, key: any) => {
//               if (value.id == row_obj.id) {
//                 value.descripcion = row_obj.descripcion;
//                 value.valor = row_obj.valor;
//               }
//               return true;
//             });
//             this.data = this.dataSource.data.length >= 1 ?  true : false
//             this.snackBar.showSuccess("Registro actualizado correctamente.", "Exito");
//           },
//           error => {
//             this.spinner.hide()
//             this.snackBar.showError( error, "Error");
//           })
//     }
//     else {
//       this.spinner.hide()
//       this.snackBar.showWarn("El registro ya existe", "Error");
//     }
//   }


// deleteRowData(row_obj: { id: number; }) {
//   this.tiposSelladoService.delete(row_obj.id)
//       .subscribe(
//         data => {
//           this.spinner.hide()
//           this.dataSource.data = this.dataSource.data.filter((value: { id: number; }, key: any) => {
//             return value.id != row_obj.id;
//           });
//           this.data = this.dataSource.data.length >= 1 ?  true : false
//           this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
//         },
//         error => {
//           this.spinner.hide()
//           this.snackBar.showError( "El registro no se puede eliminar porque tiene referencias asignadas.", "Error");
//         })

// }
}
